module.exports = __webpack_public_path__ + "static/Verizon_New_Brand_Module_Excerpt-79c56f5f71a01e57dd3409edf2056451.mp4";